import axios from "axios";
import {
  IMPORT_SUMMARY,
  IMPORTED_LEADS,
  LOADING,
  SELECTED_RECORDS,
} from "../actionType/importType";
import {
  csvDisconnect,
  csvImportUrl,
  disconnectBeyonData,
  googleImportAuthorize,
  googleImportConnect,
  googleImportDisconnect,
  googleLatestSync,
  importPreview,
  importSummary,
  importToLead,
  leadImportEmployees,
  outlookImportAuthorize,
  outlookImportConnect,
  outlookImportDisconnect,
  outlookLatestSync,
} from "../constant/Constant";
import {
  deleteAuthMethod,
  formDataPostService,
  getAuthMethod,
  postAuthMethod,
} from "../services/HttpServices";
import { formatExecutivePayload } from "../utils/formatExecutivePayload";
import { getUserInfo } from "../utils/utils";
const originURL = window.location.origin;
const baseUrl = process.env.REACT_APP_BACKEND_URL;

export const selectedRow = (payload) => {
  return {
    type: SELECTED_RECORDS,
    payload: payload,
  };
};

export const importCSV = (payload) => (dispatch) => {
  const formData = new FormData();
  formData.append("file", payload.file.get("file"));
  formData.append(
    "mappings",
    JSON.stringify(payload?.mappingItems?.filter((d) => !!d?.field)),
  );

  return formDataPostService(csvImportUrl, formData);
};

export const getPreview = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  const params = Object.entries(payload)
    ?.filter(([key, value]) => key !== "status")
    .map(([key, value]) =>
      ["sourceType"].includes(key)
        ? `${key}.equals=${value}`
        : key === "searchText"
          ? `${key}.contains=${value}`
          : `${key}=${value}`,
    )
    .join("&");
  const { id: userId } = getUserInfo();

  return getAuthMethod(
    `${importPreview}?userId.equals=${userId}&sort=fullname,asc&${params}&size=${params?.size || 10}`,
  )
    .then((res) => {
      dispatch({
        type: IMPORTED_LEADS,
        payload: {
          content: res.data,
          totalCount: res?.headers["x-total-count"],
        },
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const getSummary = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(importSummary)
    .then((res) => {
      dispatch({
        type: IMPORT_SUMMARY,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const connectToSocial = (type) => (dispatch) => {
  let method;

  switch (type) {
    case "Gmail":
      method = googleImportConnect;
      break;
    case "Outlook":
      method = outlookImportConnect;
      break;
    default:
      throw new Error(`Unsupported import type: ${type}`);
  }

  return postAuthMethod(method, { origin: originURL })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const authorizeToSocial = (payload) => (dispatch) => {
  let method;

  switch (payload?.type) {
    case "Gmail":
      method = googleImportAuthorize;
      break;
    case "Outlook":
      method = outlookImportAuthorize;
      break;
    default:
      throw new Error(`Unsupported import type: ${payload?.type}`);
  }

  return axios
    .get(`${method}?code=${payload?.code}`, {
      baseURL: baseUrl,
      headers: {
        Authorization: `Bearer ${payload?.token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        origin: originURL,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const disconnectImport = (type) => (dispatch) => {
  let method;

  switch (type) {
    case "Gmail":
      method = googleImportDisconnect;
      break;
    case "CSV":
      method = csvDisconnect;
      break;
    case "Beyondleadz data":
      method = disconnectBeyonData;
      break;
    case "Outlook":
      method = outlookImportDisconnect;
      break;
    default:
      throw new Error(`Unsupported import type: ${type}`);
  }

  return deleteAuthMethod(method)
    .then((res) => res)
    .catch((err) => err);
};

export const convertDataToLead = (payload) => (dispatch) => {
  return postAuthMethod(importToLead, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const importEmployees = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  const url = formatExecutivePayload(leadImportEmployees, payload);
  return postAuthMethod(url)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const googleLatestContactSync = () => (dispatch) => {
  return postAuthMethod(googleLatestSync)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const outlookLatestContactSync = () => (dispatch) => {
  return postAuthMethod(outlookLatestSync)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
